module.exports = __webpack_public_path__ + "img/mass-about-active@3x.png";